export default __webpack_public_path__ + "static/media/s-4.90ba4be7.jpg";